import QueryString from 'querystring'
import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import styled from 'styled-components'

import { ficur, proxy_image, qps_from_search } from '../../helpers/misc'
import routes from '../../routes'
import { Box, Text } from '../Shared/Base'
import { useFetchApi } from '../Shared/hooks'
import LinkSafe from '../Shared/LinkSafe'
import { IconChevronLeft, IconChevronRight } from '../Shared/Svg/Icons'

// import Avis from './Avis'
const LandingStyled = styled.main`
  color: var(--colorN_primary);

  .btn.is-medium {
    font-size: 1.8rem;
    padding: 16px 30px;
  }

  .h1-like {
    font-family: 'montserrat';
    font-size: 4.4rem;
    line-height: 5.4rem;

    @media screen and (max-width: 1439px) {
      font-size: 3.6rem;
      line-height: 4.6rem;
    }

    @media screen and (max-width: 599px) {
      text-align: center;
    }
  }

  .h2-title {
    font-weight: normal;
    font-size: 3.6rem;
    line-height: 4.6rem;

    @media screen and (max-width: 1439px) {
      font-size: 3.2rem;
      line-height: 4.2rem;
    }

    @media screen and (max-width: 599px) {
      text-align: center;
    }
  }

  .h2-like {
    font-family: 'montserrat';
    font-size: 3.6rem;
    line-height: 4.6rem;
  }
`

const FirstBox = styled(Box)`
  background: linear-gradient(180deg, rgba(162, 221, 255, 0.24) 0%, rgba(255, 255, 255, 0) 33.47%);
  position: relative;

  @media screen and (max-width: 1110px) {
    br {
      display: none;
    }
  }

  .illustration {
    @media screen and (max-width: 1140px) {
      width: 450px;
    }
    @media screen and (max-width: 1000px) {
      width: 400px;
    }
  }

  .apps {
    position: relative;

    &::after {
      content: '';
      background-image: url('https://res.cloudinary.com/loueragile/image/upload/v1601888304/web/jinka/Gratuit.png');
      background-size: 173px 83px;
      width: 173px;
      height: 83px;
      position: absolute;
      left: 450px;
      top: -45px;

      @media screen and (max-width: 1220px) {
        display: none;
      }
    }
  }
`

const BoxCards = styled(Box)`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 40px;

  @media screen and (max-width: 1023px) {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 30px;
  }

  @media screen and (max-width: 800px) {
    grid-template-columns: 1fr;
    grid-gap: 30px;
  }
`

const BoxCard = styled(Box)`
  box-shadow: 0px 0px 30px 5px rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  background-color: white;
  cursor: pointer;

  &:hover {
    box-shadow: 0px 0px 30px 5px rgba(0, 0, 0, 0.07);
  }

  .photo {
    height: 0;
    position: relative;
    padding-bottom: 66.66%;
  }

  .img {
    border-radius: 5px 5px 0 0;
    height: 100%;
    width: 100%;
    object-fit: cover;
    position: absolute;
    left: 0;
    top: 0;
  }

  .head {
    position: relative;

    .top,
    .bottom {
      position: absolute;
      right: 10px;
      display: inline-grid;
      grid-template-columns: auto auto;
      z-index: 2;
    }

    .top {
      top: 10px;
    }

    .bottom {
      bottom: 10px;
    }
  }

  .tag {
    padding: 4px 10px;
    border-radius: 5px;
    font-size: 1.4rem;
    text-transform: uppercase;

    + .tag {
      margin-left: 10px;
    }

    &.premium {
      background-color: var(--colorPremium);
      color: white;
    }

    &.primary {
      background-color: var(--colorBg_primary);
      color: var(--colorPrimary);
      display: inline-grid;
      grid-template-columns: auto auto;
      grid-gap: 10px;
      align-items: center;
    }

    &.tertiary {
      background-color: white;
      color: var(--colorText);
    }

    &.negative {
      background-color: var(--colorBg_negative);
      color: var(--colorNegative);
    }
  }

  .content {
    padding: 10px 20px 15px 20px;

    .title {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
      color: var(--colorText);
      font-weight: bold;
    }

    .bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 20px;
    }
  }

  .icons {
    display: flex;
    align-items: center;
  }

  .icon {
    background-color: white;
    border-radius: 100%;
    border: 1px solid var(--colorThin);
    width: 38px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      stroke: var(--colorLight);
    }

    &.active {
      svg {
        stroke: var(--colorNegative);
        fill: var(--colorNegative);
      }
    }

    + .icon {
      margin-left: 10px;
    }
  }
`

const CardTitle = ({ ad }) => {
  if (ad.new_real_estate) {
    const ad_rooms = ad.new_real_estate.properties.map(x => x.room)
    const ad_room = [Math.min(...ad_rooms), Math.max(...ad_rooms)]

    return (
      <Text className="title fz-18">
        {ad.new_real_estate.programme_name}
        {ad_room[0] === ad_room[1] ? (
          <Box as="span">
            {' '}
            - {ad_room[0]} {ad_room[0] > 1 ? 'pcs' : 'pc'}
          </Box>
        ) : (
          <Box as="span">
            {' '}
            - {ad_room[0]} à {ad_room[1]} pcs
          </Box>
        )}
      </Text>
    )
  }

  return (
    <Text className="title fz-18">
      {ad.city || ad.postal_code} - {ad.area}m² - {ad.room}p.
    </Text>
  )
}

const no_pic_url =
  'https://res.cloudinary.com/loueragile/image/upload/v1588422076/web/no-picture.png'
const Card = ({ ad }) => {
  const rent = ad.new_real_estate
    ? Math.min(...ad.new_real_estate.properties.map(x => x.price))
    : ad.rent
  const history = useHistory()

  const onClick = React.useCallback(() => {
    history.push(routes.ad.route.reverse({ id: ad.id }))
  }, [ad.id, history])

  return (
    <BoxCard onClick={onClick}>
      <Box className="head">
        <Box className="photo">
          <img
            alt="logement"
            className="img"
            src={
              ad.images && ad.images.split(',')[0]
                ? proxy_image(ad.images.split(',')[0])
                : no_pic_url
            }
            onError={e => {
              if (e.target.src !== no_pic_url) {
                e.target.src = no_pic_url
              }
            }}
          />
        </Box>
      </Box>
      <Box className="content">
        <CardTitle ad={ad} />

        <Text className="fz-16" color="light">
          {ad.city} {ad.postal_code ? `(${ad.postal_code})` : ''}
        </Text>

        <Box className="bottom">
          <Box color="text" className="fz-24">
            {Boolean(ad.new_real_estate) && (
              <Text as="p" fontSize={13} lineHeight="1">
                À partir de
              </Text>
            )}
            <strong>{ficur(rent)}</strong>
          </Box>
        </Box>
      </Box>
    </BoxCard>
  )
}

const PartnerAgency = ({ match }) => {
  const location = useLocation()
  const qps = qps_from_search(location.search)

  const current_page = React.useMemo(() => parseInt(qps.page || 1, 10), [qps.page])

  const fetcher = useFetchApi()
  const [agency, set_agency] = React.useState(null)

  const { partner_source } = match.params

  const reload = React.useCallback(async () => {
    // set_agency(null)
    const res = await fetcher(`agency/${partner_source}?page=${current_page}`)
    set_agency(res)
  }, [current_page, fetcher, partner_source])

  React.useEffect(() => {
    reload()
  }, [reload])

  if (!agency)
    return (
      <FirstBox
        as="section"
        maxWidth="100%"
        mx="auto"
        px={{ lg: 0, xs: 20 }}
        pt={{ md: 200, xs: 150 }}
        height="100vh"
      />
    )

  return (
    <LandingStyled>
      <FirstBox
        as="section"
        maxWidth="100%"
        mx="auto"
        px={{ lg: 0, xs: 20 }}
        pt={{ md: 200, xs: 150 }}
      >
        <Box maxWidth={1200} mx="auto" position="relative">
          <Box
            as="img"
            src={agency.info.image_url}
            alt=""
            style={{ height: 500, width: '100%', objectFit: 'cover' }}
            borderRadius={10}
          />
          <Box
            width={{ xs: 'auto', md: 500 }}
            maxWidth="100%"
            p={20}
            position="absolute"
            bg="white"
            bottom="-50px"
            left={{ xs: 20, md: 80 }}
            right={{ xs: 20, md: 0 }}
            borderRadius={10}
            boxShadow={'0px 0px 30px 5px rgba(0,0,0,0.05);'}
          >
            {agency.info.logo ? (
              <>
                <Box as="img" src={agency.info.logo} alt="" height={60} />
                <Text
                  as="span"
                  color="n_secondary"
                  fontSize={24}
                  ml={20}
                  fontWeight="bold"
                  style={{ textTransform: 'capitalize' }}
                >
                  {agency.info.label}
                </Text>
              </>
            ) : (
              <Text
                color="n_secondary"
                fontSize={24}
                fontWeight="bold"
                style={{ textTransform: 'capitalize' }}
              >
                {agency.info.label}
              </Text>
            )}
            {agency.info.website_url && (
              <Box
                as="a"
                href={agency.info.website_url}
                style={{ textDecorationLine: 'underline' }}
                mt={10}
                display="inline-block"
              >
                {agency.info.website_url}
              </Box>
            )}
            <Text color="text" mt={20}>
              {agency.info.description}
            </Text>
            <Text />
          </Box>
        </Box>
      </FirstBox>

      <BoxCards maxWidth={1200} mx="auto" position="relative" px={{ lg: 0, xs: 20 }} mt={130}>
        {agency && agency.ads.map((x, i) => <Card key={i} ad={x} />)}
      </BoxCards>

      <Box my={50}>
        <Pagination
          nb_pages={agency.nb_pages}
          partner_source={partner_source}
          current_page={current_page}
        />
      </Box>
    </LandingStyled>
  )
}

const PageLi = styled.li`
  margin: 0 5px;

  a {
    color: ${props => (props.disabled ? 'var(--colorThin)' : 'var(--colorText)')};
    cursor: ${props => (props.disabled ? 'default' : 'pointer')};
    display: flex;
    align-items: center;

    &.page  {
      display: flex;
      justify-content: center;
      padding: 10px;
      width: 30px;
      height: 30px;
      border-radius: 5px;
      background: ${props => (props.active ? 'var(--colorN_secondary)' : 'transparent')};
      color: ${props => (props.active ? 'white' : 'var(--colorText)')};
    }
  }
`

const Pagination = ({ nb_pages, partner_source, current_page }) => {
  const pathToPage = React.useCallback(
    ({ page }) => {
      return {
        pathname: routes.partner_agency.route.reverse({ partner_source }),
        search: QueryString.stringify({
          page
        })
      }
    },
    [partner_source]
  )

  if (nb_pages <= 1) return null

  return (
    <Box
      as="ul"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexWrap="wrap"
      mt={50}
      mb={150}
    >
      <PageLi disabled={current_page <= 1}>
        <Box
          as={LinkSafe}
          to={pathToPage({ page: current_page - 1 })}
          onClick={e => current_page <= 1 && e.preventDefault()}
          mr={10}
        >
          <IconChevronLeft width={15} height={15} fill="var(--colorLight)" />
        </Box>
      </PageLi>
      {Array(nb_pages)
        .fill(null)
        .map((_, p) => {
          return (
            <PageLi key={p} active={p + 1 === current_page}>
              <LinkSafe className="page" to={pathToPage({ page: p + 1 })}>
                {p + 1}
              </LinkSafe>
            </PageLi>
          )
        })}
      <PageLi disabled={current_page >= nb_pages}>
        <Box
          as={LinkSafe}
          to={pathToPage({ page: current_page + 1 })}
          onClick={e => current_page >= nb_pages && e.preventDefault()}
          ml={10}
        >
          <IconChevronRight width={15} height={15} fill="var(--colorLight)" />
        </Box>
      </PageLi>
    </Box>
  )
}

export default PartnerAgency
